// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-container{
    margin-top: 130px;
    display: flex;
    flex-direction: column;

}

.page-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.page-info h1 {
    font-family: 'Philosopher', serif;
    font-size: 24px;
    font-weight: 500;
    margin: 0px;
}

.page-info-navigation {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.page-info-navigation-icons {
    margin: 10px;
}

.page-info-navigation h5 {
    font-family: 'Philosopher', sans-serif;
    font-size: 14px;
    font-weight: 500;
    margin: 10px;

}

.about-content{
    display: flex;
    flex-direction: row;
    margin-top: 30px;

    align-items: flex-start;
    
}

.about-content img{
    width:100%;
    margin:0px 30px;
}

.about-content-text p{
    font-family: 'Poppins',sans-serif;
    font-size: 15px;
    font-weight: 500;
    /* color:#666; */
    letter-spacing: 1px;
    text-align: left;
    margin: 20px;
}

.about-content-text h3{
    text-align: left;
    margin: 20px;
    margin-bottom: 30px;
    margin-top: 0px;
}

@media screen and (max-width:768px){
    .about-container {
            margin-top: 180px;
            display: flex;
            flex-direction: column;
    
        }
    .about-content{
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    align-items: center;
    
}
.about-content img {
    width: 90%;
    margin: 10px;
}
    
}`, "",{"version":3,"sources":["webpack://./src/Styles/About.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;;IAEhB,uBAAuB;;AAE3B;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI;YACQ,iBAAiB;YACjB,aAAa;YACb,sBAAsB;;QAE1B;IACJ;IACA,aAAa;IACb,sBAAsB;IACtB,gBAAgB;;IAEhB,mBAAmB;;AAEvB;AACA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA","sourcesContent":[".about-container{\n    margin-top: 130px;\n    display: flex;\n    flex-direction: column;\n\n}\n\n.page-info {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.page-info h1 {\n    font-family: 'Philosopher', serif;\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0px;\n}\n\n.page-info-navigation {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.page-info-navigation-icons {\n    margin: 10px;\n}\n\n.page-info-navigation h5 {\n    font-family: 'Philosopher', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    margin: 10px;\n\n}\n\n.about-content{\n    display: flex;\n    flex-direction: row;\n    margin-top: 30px;\n\n    align-items: flex-start;\n    \n}\n\n.about-content img{\n    width:100%;\n    margin:0px 30px;\n}\n\n.about-content-text p{\n    font-family: 'Poppins',sans-serif;\n    font-size: 15px;\n    font-weight: 500;\n    /* color:#666; */\n    letter-spacing: 1px;\n    text-align: left;\n    margin: 20px;\n}\n\n.about-content-text h3{\n    text-align: left;\n    margin: 20px;\n    margin-bottom: 30px;\n    margin-top: 0px;\n}\n\n@media screen and (max-width:768px){\n    .about-container {\n            margin-top: 180px;\n            display: flex;\n            flex-direction: column;\n    \n        }\n    .about-content{\n    display: flex;\n    flex-direction: column;\n    margin-top: 30px;\n\n    align-items: center;\n    \n}\n.about-content img {\n    width: 90%;\n    margin: 10px;\n}\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
